import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import OperacionPage from "@/pages/OperacionPage";
import WizardPage from "@/pages/WizardPage";
import PersonasPage from "@/pages/PersonasPage";
import InmueblesPage from "@/pages/InmueblesPage";
import LandingPage from "@/pages/LandingPage";
import CapacitacionPage from "@/pages/CapacitacionPage";
import AdminCopilotoPage from "@/pages/AdminCopilotoPage";
import AdminUsersPage from "@/pages/AdminUsersPage";
import AdminSettingsPage from "@/pages/AdminSettingsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import MiPerfilPage from "@/pages/MiPerfilPage";
import AdminPlantillasPage from "@/pages/AdminPlantillasPage";
import AdminPlantillaEditorPage from "@/pages/AdminPlantillaEditorPage";
import TermsAcceptanceGate from "@/components/TermsAcceptanceGate";
import InstalarPage from "@/pages/InstalarPage";
import { PendientesAviso } from "@/components/copiloto/PendientesAviso";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-600">Cargando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "content_editor" && !loc.pathname.startsWith("/app/admin/copiloto") && loc.pathname !== "/app/instalar") {
    return <Navigate to="/app/admin/copiloto" replace />;
  }
  // Gate legal — bloquea la app hasta que el usuario acepte la versión vigente.
  // Aplica a los 3 tipos de cuenta (asesor, inmobiliaria madre, subusuario)
  // y a cuentas viejas migrando.
  return <TermsAcceptanceGate><PendientesAviso />{children}</TermsAcceptanceGate>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/aviso-privacidad" element={<PrivacyPage />} />
            <Route path="/terminos" element={<TermsPage />} />
            <Route path="/app" element={<Protected><DashboardPage /></Protected>} />
            <Route path="/app/operaciones/:id" element={<Protected><OperacionPage /></Protected>} />
            <Route path="/app/operaciones/:id/nuevo/:tipo" element={<Protected><WizardPage /></Protected>} />
            <Route path="/app/documentos/:did" element={<Protected><WizardPage /></Protected>} />
            <Route path="/app/admin/plantillas" element={<Protected><AdminPlantillasPage /></Protected>} />
            <Route path="/app/admin/plantillas/:clave" element={<Protected><AdminPlantillaEditorPage /></Protected>} />
            <Route path="/app/perfil" element={<Protected><MiPerfilPage /></Protected>} />
            <Route path="/app/personas" element={<Protected><PersonasPage /></Protected>} />
            <Route path="/app/inmuebles" element={<Protected><InmueblesPage /></Protected>} />
            <Route path="/app/capacitacion" element={<Protected><CapacitacionPage /></Protected>} />
            <Route path="/app/admin/copiloto" element={<Protected><AdminCopilotoPage /></Protected>} />
            <Route path="/app/admin/usuarios" element={<Protected><AdminUsersPage /></Protected>} />
            <Route path="/app/admin/ajustes" element={<Protected><AdminSettingsPage /></Protected>} />
            <Route path="/app/instalar" element={<Protected><InstalarPage /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-center" />
      </AuthProvider>
    </div>
  );
}

export default App;
